/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasPathItem } from '../../models/OasPathItem';
import { OasPaths } from '../../models/OasPaths';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasPaths
 */
export class Oas20Paths extends OasPaths {
    /**
     * @see io.apicurio.datamodels.openapi.models.OasPaths#createPathItem(java.lang.String)
     * @param {string} path
     * @return {OasPathItem}
     */
    public createPathItem(path : string) : OasPathItem {
        let pathItem : Oas20PathItem = new Oas20PathItem(path);
        pathItem._ownerDocument = this.ownerDocument();
        pathItem._parent = this;
        return pathItem;
    }

    constructor() {
        super();
    }
}
Oas20Paths["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Paths";
Oas20Paths["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas20PathItem } from './Oas20PathItem';

